export const NEAR_POINT_CONVERGENCE_METRIC_QUERY = `
nearPointConvergence {
    metrics {
       breakPoint
       recoveryPoint
    }
}
`;
